import { Pipe, PipeTransform } from '@angular/core';
import { User, UserUtilites } from '../../_models';

@Pipe({
    name: 'userName',
    standalone: false
})
export class UserNamePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const user = new User(value);
    return UserUtilites.getUserFirstNameSpaceLastName(user)
  }

}
